import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { UseCasesContext } from "../../../../context/useCases"
import { FiledType, Form } from "../../../components/form"
import { Menu } from "../../../components/menu"
import { useTypedSelector } from "../../../../hooks/useTypedSelector"

export const LandingAdd = () => {
    const navigate = useNavigate();
    
    let { id } = useParams();

    let useCases = useContext(UseCasesContext)
    const [form, setForm] = useState<{
        domain: string,
        imagesPath: string,
        isWithThumb: boolean,
        thumbWidth: number,
        thumbHeight: number,
        thumbPostfix: string,
        bigImageWidth: number,
    }>({
        domain: "",
        imagesPath: "",
        isWithThumb: false,
        thumbWidth: 320,
        thumbHeight: 0,
        thumbPostfix: "m",
        bigImageWidth: 1280,

    })

    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (form.domain !== "" && form.bigImageWidth !== 0) {
            if (id) {
                useCases?.landingUseCase.UpdateLanding(id!, form.domain!, form.imagesPath!, form.isWithThumb!, form.thumbWidth!, form.thumbHeight!, form.thumbPostfix!, form.bigImageWidth!, () => { navigate(-1) })
            } else {
                useCases?.landingUseCase.CreateLanding(form.domain!, form.imagesPath!, form.isWithThumb!, form.thumbWidth!, form.thumbHeight!, form.thumbPostfix!, form.bigImageWidth!, () => { navigate(-1) })
            }
        }
    }

    const updateForm = (name: string, value: any) => {
        setForm({
            ...form,
            [name]: value,
        })
    }

    const readLandingById = async (id: UniqueId) => {
        let response = await useCases?.landingUseCase.ReadLandingById(id)
        if (response instanceof Error) {

        } else {
            setForm({
                domain: response?.Domain()!,
                imagesPath: response?.ImagesPath()!,
                isWithThumb: response?.IsWithThumb()!,
                thumbWidth: response?.ThumbWidth()!,
                thumbHeight: response?.ThumbHeight()!,
                thumbPostfix: response?.ThumbPostfix()!,
                bigImageWidth: response?.BigImageWidth()!,
            })
        }
    }

    const formatDate = (day: Date) => {
        const yyyy = day.getFullYear();
        let mm = (day.getMonth() + 1).toString(); // Months start at 0!
        let dd = day.getDate().toString();

        if (dd.length == 1) dd = '0' + dd;
        if (mm.length == 1) mm = '0' + mm;

        return dd + '.' + mm + '.' + yyyy;
    }

    useEffect(() => {
        if (id) {
            readLandingById(id)
        }
    }, [id])

    const landings = useTypedSelector(({ landing }) => {
        return landing
    })

    useEffect(() => {
        if (id) {
            readLandingById(id)
        }
    }, [id])

    return (
        <div className="layout-page" >
            <Menu />
            <div className="content-wrapper" >
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row mx-1">
                        <div className="col-sm-12 col-md-12">
                            <h4 className="fw-bold py-3 mb-4"><span className="text-muted fw-light">Лендинг /</span> {id ? "Редактировать лендинг" : "Добавить лендинг"}</h4>
                        </div>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">{id ? "Редактирование лендинга" : "Добавление лендинга"}</h5>
                            </div>
                            <div className="card-body">
                                <Form
                                    state={{
                                        loading: false,
                                        error: "",
                                    }}

                                    submit={submit}

                                    fields={[
                                        {
                                            name: "domain",
                                            title: "Домен",
                                            placeholder: "Укажите домен",
                                            value: form.domain,
                                            type: FiledType.Text,
                                        },
                                        {
                                            name: "imagesPath",
                                            title: "Путь к ходу строительства (пример /img/hod)",
                                            placeholder: "Укажите путь к ходу строительства",
                                            value: form.imagesPath,
                                            type: FiledType.Text,
                                        },
                                        {
                                            name: "bigImageWidth",
                                            title: "Ширина большого фото",
                                            placeholder: "Укажите ширину большого фото",
                                            value: form.bigImageWidth,
                                            type: FiledType.Number,
                                        },
                                        {
                                            name: "isWithThumb",
                                            title: "Генерация превью",
                                            placeholder: "Укажите нужна ли генерация превью",
                                            value: form.isWithThumb,
                                            type: FiledType.CheckBox,
                                        },
                                        {
                                            name: "thumbWidth",
                                            title: "Ширина превью",
                                            placeholder: "Укажите ширину превью",
                                            value: form.thumbWidth,
                                            type: FiledType.Number,
                                        },
                                        {
                                            name: "thumbHeight",
                                            title: "Высота превью (оставьте 0, если нужно сохранить aspect ratio)",
                                            placeholder: "Укажите высоту превью",
                                            value: form.thumbHeight,
                                            type: FiledType.Number,
                                        },
                                        {
                                            name: "thumbPostfix",
                                            title: "Суффикс к названию превью (по умолчанию m)",
                                            placeholder: "Укажите суффикс к названию превью",
                                            value: form.thumbPostfix,
                                            type: FiledType.Text,
                                        },
                                    ]}
                                    btnSmall={true}
                                    submitBtnTitle={"Сохранить"}
                                    updateForm={updateForm}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
